import { getFunctions, httpsCallable } from "firebase/functions";
import { mapFirebaseError } from "./errorMapper";
export class FirebaseAdminRepository {
    functions = getFunctions(undefined, "us-central1");
    async setRole(uid, role) {
        try {
            await httpsCallable(this.functions, "adminSetRole")({ uid, role });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async removeRole(uid) {
        try {
            await httpsCallable(this.functions, "adminRemoveRole")({ uid });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async takedownTarget(type, id) {
        try {
            await httpsCallable(this.functions, "adminTakedownTarget")({ type, id });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async setUserDisabled(uid, disabled) {
        try {
            await httpsCallable(this.functions, "adminSetUserDisabled")({ uid, disabled });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async forcePurge(uid) {
        try {
            await httpsCallable(this.functions, "adminForcePurge")({ uid });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseAdminRepository.js.map